import { useIntl } from 'react-intl'
import {
  ContactPlain,
  MemberPlainDefault,
  TeamPlainDefault
} from '../../stories/atoms/icons/users'
import NotFoundComponent from '../../stories/molecules/not-found'
import { copyProjectMembersTabOptions } from '../constants'
import { CopyMembersTabEmptyMembersContainer } from '../styled-components'

const iconStyle = {
  width: '80px',
  height: '80px',
  opacity: 0.5
}

const emptyStateByVariant = {
  [copyProjectMembersTabOptions.MEMBERS]: {
    Icon: MemberPlainDefault,
    labelId: 'members'
  },
  [copyProjectMembersTabOptions.TEAMS]: {
    Icon: TeamPlainDefault,
    labelId: 'teams_titleTeamGroups'
  },
  [copyProjectMembersTabOptions.CONTACTS]: {
    Icon: ContactPlain,
    labelId: 'personas_contacts'
  }
}

const CopyProjectMembersEmpty = ({
  variant = copyProjectMembersTabOptions.MEMBERS,
  searchValue = ''
}) => {
  const { formatMessage } = useIntl()

  const { Icon, labelId } =
    emptyStateByVariant[variant] ??
    emptyStateByVariant[copyProjectMembersTabOptions.MEMBERS]

  const memberType = formatMessage({ id: labelId })
  const hasSearchValue = !!searchValue.trim()

  const controlHeight = {
    maxHeight: hasSearchValue ? '350px' : '400px',
    minHeight: hasSearchValue ? '350px' : '400px'
  }

  return (
    <CopyMembersTabEmptyMembersContainer style={controlHeight}>
      <NotFoundComponent
        icon={<Icon style={iconStyle} />}
        header={
          hasSearchValue
            ? formatMessage({ id: 'no_result_found' })
            : formatMessage(
                { id: 'no_members_yet' },
                { member_type: memberType }
              )
        }
        description={
          hasSearchValue
            ? formatMessage({ id: 'no_result_found_description' })
            : formatMessage(
                { id: 'no_members_yet_description' },
                { member_type: memberType }
              )
        }
      />
    </CopyMembersTabEmptyMembersContainer>
  )
}

export default CopyProjectMembersEmpty
